import { useCallback, useRef } from "react";

import { useInvitationSignUp } from "@/hooks/use-auth-client";

import { InputPasswordField } from "@/components/ui/form/fields/input-field/input-password";
import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

import { useInvitationCompanySignUpForm } from "./_hooks/use-invitation-company-sign-up-form";
import { AuthForm } from "../../_components/auth-form";

type Props = {
	companyID: string;
	oneTimePassword: string;
};

export const AuthInvitationCompanySignUp = ({ companyID, oneTimePassword }: Props) => {
	const {
		invitationCompanySignUpForm,
		errors,
		passwordErrorMessage,
		disabled,

		onChangeInvitationCompanySignUpForm,
		onInitInvitationCompanySignUpForm,
	} = useInvitationCompanySignUpForm();

	const { invitationSignUp } = useInvitationSignUp();

	const isProcessingRef = useRef(false);

	const handleChangeEmail = useCallback(
		(value: string) => {
			onChangeInvitationCompanySignUpForm("email", value);
		},
		[onChangeInvitationCompanySignUpForm],
	);

	const handleChangePassword = useCallback(
		(value: string) => {
			onChangeInvitationCompanySignUpForm("password", value);
		},
		[onChangeInvitationCompanySignUpForm],
	);

	const handleSubmit = async (_e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
		if (isProcessingRef.current) return;

		isProcessingRef.current = true;

		const { email, password } = invitationCompanySignUpForm;
		const clientMetadata = {
			companyID,
			oneTimePass: oneTimePassword,
		};
		await invitationSignUp({ email, password, clientMetadata });
		onInitInvitationCompanySignUpForm();

		isProcessingRef.current = false;
	};

	return (
		<AuthForm
			formTitle="アカウント作成"
			handlePrimaryButtonClick={handleSubmit}
			primaryButtonText="アカウントを作成する"
			disabled={disabled}
		>
			<InputTextField
				label="メールアドレス"
				autoComplete="email"
				name="email"
				errorMessage={errors?.email?.at(0)}
				type="email"
				placeholder="sample@chillnn.com"
				value={invitationCompanySignUpForm.email}
				handleChange={handleChangeEmail}
			/>
			<InputPasswordField
				name="password"
				errorMessage={passwordErrorMessage}
				label="パスワード"
				autoComplete="new-password"
				placeholder="••••••••"
				value={invitationCompanySignUpForm.password}
				onChange={handleChangePassword}
			/>
		</AuthForm>
	);
};
